import React from 'react';

import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';

import Confirmation from '../../../components/Forms/Confirmation';
import useStyles from '../../styles';

const Details = ({
  onDelete,
  isOpen,
  onClose,
  data
}) => {

  const classes = useStyles();

  return <Dialog
    open={isOpen}
    onClose={onClose}
    scroll='body'
  >
    <Paper className={classes.dialog}>
      <Grid container justify="space-around" alignItems="center">
        <Delete {...{onClose, onDelete, data}}/>
      </Grid>
    </Paper>
  </Dialog>;

};

const Delete = ({onClose, onDelete, data}) => <Confirmation
  message={`Gostaria de apagar permanentemente o usuário ${data.userName}?`}
  onSubmit={onDelete}
  {...{onClose}}
/>;

export default Details;
